import PreviewBanner from '../PreviewBanner';

const PreviewQueueBanner = (props) => {
  const { promobanner } = props;

  return (
    <div className="banner-background">
      { 
        Array.isArray(promobanner) && promobanner.map((banner, index) => {
          return (
            <PreviewBanner key={index} values={banner.templateInfo} />
          );
        })
      }
    </div>
  )
}

export default PreviewQueueBanner;